import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { ENDPOINTS } from 'src/app/shared/endpoints/api-endpoints';

export interface JobApplication {
  application_id: string;
  applied_at: string;
  user: {
    id: string;
    email: string;
    phone: string | null;
    name: string | null;
    gender: string | null;
    age: string | null;
    skills: { name: string }[];
    languages: { name: string }[];
  };
  job: {
    id: string;
    title: string;
    category: string;
    job_type: string;
    short_desc: string;
    is_online_application: boolean;
    location: {
      area_code: string;
      city_code: string;
      city_name: string;
      state_code: string;
    };
    provider: {
      id: string;
      name: string;
      logo_url: string;
      long_desc: string;
      short_desc: string;
    };
    compensation: {
      type: string;
      range: {
        max: number;
        min: number;
      };
      currency: string;
    };
  };
}

export interface JobListingResponse {
  items: JobApplication[];
  total: number;
  page: number;
  limit: number;
  pages: number;
}

export interface JobListingFilters {
  page?: number;
  limit?: number;
  job_id?: string;
  category?: string;
  job_type?: string;
  city_code?: string;
  is_online_application?: boolean;
  search?: string;
}

@Injectable({
  providedIn: 'root'
})
export class AdminApiService {

  private baseUrl = environment.API.SAMHITA_ONDC.BASE_URL;

  constructor(private http: HttpClient) { }

  getJobApplications(filters: JobListingFilters = {}): Observable<JobListingResponse> {
    let params = new HttpParams();
    
    if (filters.page) params = params.set('page', filters.page.toString());
    if (filters.limit) params = params.set('limit', filters.limit.toString());
    if (filters.job_id) params = params.set('job_id', filters.job_id);
    if (filters.category) params = params.set('category', filters.category);
    if (filters.job_type) params = params.set('job_type', filters.job_type);
    if (filters.city_code) params = params.set('city_code', filters.city_code);
    if (filters.is_online_application !== undefined) {
      params = params.set('is_online_application', filters.is_online_application.toString());
    }
    if (filters.search) params = params.set('search', filters.search);

    return this.http.get<JobListingResponse>(ENDPOINTS.SAMHITA_ONDC.OFF_NETWORK_APPLICATIONS, { params });
  }

  exportApplications(jobId?: string): void {
    let url = `${ENDPOINTS.SAMHITA_ONDC.OFF_NETWORK_APPLICATIONS_EXPORT}?format=csv`;
    if (jobId) {
      url += `&job_id=${jobId}`;
    }
    window.open(url, '_blank');
  }
}

